<template>
    <div>
        <BrandSeries @pick="pickBrandSeries" />
        <PriceRange @pick="pickPriceRange" />
        <van-list>
            <UsedCarListItem v-for="item in data" :key="item.id" :item="item" class="item" />
        </van-list>
        <UsedCarFooter />
    </div>
</template>

<script>
import { 
    NavBar, 
    List
} from 'vant'

import { UsedCarShopApi } from '@/api/usedcar'
import BrandSeries from '@/view/usedcar/components/brandseries'
import PriceRange from '@/view/usedcar/components/pricerange'
import UsedCarListItem from '@/view/usedcar/components/usedcarlistitem'
import UsedCarFooter from '@/view/usedcar/components/usedcarfooter'

export default {
    components: {
        [NavBar.name]: NavBar,
        [List.name]: List,
        BrandSeries,
        PriceRange,
        UsedCarListItem,
        UsedCarFooter
    },
    data() {
        return {
            data: [],
            loading: false,
            finished: false,
            total: 0,
            query: {
                brand: null, // 改装升级
                series: null, // 所有
                title: null,
                price_range: null,
                state: 1,
                page: 1,
                page_size: 10
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            this.axios.get(UsedCarShopApi, { params: this.query}).then((ret) => {
                console.log(ret)
                that.loading = false
                that.total = ret.count
                if (ret.results == null || ret.results.length ===0 ) {
                    that.finished = true
                    return
                }
                that.data = ret.results
                if (that.data.length >= that.total) {
                    that.finished = true
                }
            })
        },
        pickBrandSeries(obj) {
            this.query.brand = (obj.brand == 0 ? null : obj.brand)
            this.query.series = (obj.series == 0? null : obj.series)
            this.query.price_range = null
            this.data = []
            this.getData()
        },
        pickPriceRange(obj) {
            console.log('pickPriceRange')
            console.log(obj)
            this.query.price_range = obj.id
            this.data = []
            this.getData()
        }
    }
}
</script>

